import { memo, FC, SVGProps } from "react"

export const ExpanderRightIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => (
  <svg width="4" height="6" viewBox="0 0 4 6" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path d="M3.46667 3.41184L0.8 5.41184C0.470382 5.65905 -2.57013e-08 5.42386 -4.37114e-08 5.01184L-2.18557e-07 1.01184C-2.36567e-07 0.599818 0.470382 0.364627 0.8 0.611841L3.46667 2.61184C3.73333 2.81184 3.73333 3.21184 3.46667 3.41184Z" />
  </svg>
))
export default ExpanderRightIcon
